import Instance from "../../../../Axios";

// New Actions for the app

const EditCredDestinatario = (destId, yData) => async (dispatch) => {
  await Instance()
    .put(`/credenciacoes/credDestinatario/${destId}`, { yData })
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: "EDIT_CRED_DESTINATARIO", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default EditCredDestinatario;
